import { useTranslation } from 'react-i18next'
import { Alert, AlertDescription, AlertTitle } from './ui/alert'

/**
 * The standard "you may not do this here" page state.
 *
 * Rendered in place of a create/edit form when the caller lacks the write
 * permission the page needs. Deep-linking straight to `…/create` must not hand
 * a read-only member a form whose Save can only ever return 403 — the route
 * `read` guard (lib/route-permissions.ts) lets them onto the section, this
 * covers the write half.
 *
 * The copy is the same one the API client raises on a real 403
 * (`roles:permission_denied`), so a denial reads identically whether it was
 * anticipated by the UI or answered by the backend.
 */
export function PermissionDeniedState({ permission }: { permission?: string }) {
    const { t } = useTranslation('roles')

    return (
        <div className="p-6" data-testid="permission-denied-state">
            <Alert>
                <AlertTitle>{t('permission_denied.title')}</AlertTitle>
                <AlertDescription>
                    {permission
                        ? t('permission_denied.description_with_permission', { permission })
                        : t('permission_denied.description')}
                </AlertDescription>
            </Alert>
        </div>
    )
}
